import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerWhitelist.graphql';
import { Query, QueryinfluencerWhitelistArgs } from '../../__generated__/globalTypes';

export const useInfluencerWhitelistQuery = (options?: QueryHookOptions<Query, QueryinfluencerWhitelistArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerWhitelistArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerWhitelistLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerWhitelistArgs>
): QueryResult<Query, QueryinfluencerWhitelistArgs> & {
  getInfluencerWhitelist: LazyQueryExecFunction<Query, QueryinfluencerWhitelistArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerWhitelist, result] = useLazyQuery<Query, QueryinfluencerWhitelistArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerWhitelist, ...result };
};

export const useInfluencerWhitelistPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerWhitelist = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerWhitelistArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerWhitelistArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerWhitelist };
};
// Suspense Query Hooks
export const useInfluencerWhitelistSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerWhitelistArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerWhitelistArgs>(QUERY, {
    ...options
  });

  return result;
};
